import React from 'react';
import Modal from 'react-modal';

import styles from './ClosedAccountModal.module.scss';

Modal.setAppElement('#root');

const customStyles = {
  content: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '480px',
    maxHeight: '90vh',
    padding: 0,
    border: 'none',
    borderRadius: '16px',
    overflow: 'auto',
    background: '#fff',
  },
  overlay: {
    backgroundColor: 'rgba(15, 23, 42, 0.6)',
    zIndex: 5,
  },
};

// MT-1765: same texts as MojoLoadBalancer/packages/crm/tos_closure.py (keep in sync). Used for
// the ?status=closed_tos / logged_out_as_fraud redirects; the login API sends its own copy.
const TEXT = {
  title: 'Your account has been closed',
  decision:
    "This account was closed for a violation of Mojo's Terms of Service. The decision is final and cannot be reversed through support.",
  refunds: 'Refunds are not issued for accounts closed for cause.',
  hold: 'Any remaining funds are held for a minimum of 180 days.',
  contact:
    'Questions must be submitted in writing to compliance@mojosells.com. Phone support is not available for closed accounts.',
  pinLabel: 'Account PIN for written requests:',
};

export const closedAccountContent = ({ pin = '', hold = false } = {}) => ({
  title: TEXT.title,
  paragraphs: [
    TEXT.decision,
    hold ? `${TEXT.refunds} ${TEXT.hold}` : TEXT.refunds,
    TEXT.contact,
  ],
  pin: pin ? String(pin) : '',
});

const LockIcon = () => (
  <svg
    viewBox="0 0 24 24"
    width="30"
    height="30"
    fill="none"
    stroke="#475569"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

/**
 * Closed-account modal (account closed for a Terms of Service violation).
 * One title, three short paragraphs, the account PIN as the reference for
 * written requests, and only a Close button: no support phone, no links.
 */
export default function ClosedAccountModal({ content, onClose }) {
  if (!content) {
    return null;
  }
  return (
    <Modal
      isOpen
      style={customStyles}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      contentLabel={content.title}
    >
      <div className={styles.Wrap} data-testid="closed-account-modal">
        <div className={styles.Header}>
          <div className={styles.Orb}>
            <LockIcon />
          </div>
        </div>
        <div className={styles.Content}>
          <h2 className={styles.Title}>{content.title}</h2>
          {content.paragraphs.map((paragraph) => (
            <p className={styles.Paragraph} key={paragraph}>
              {paragraph}
            </p>
          ))}
          {content.pin && (
            <div className={styles.Pin}>
              {TEXT.pinLabel} <b>{content.pin}</b>
            </div>
          )}
          <button className={styles.Button} type="button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
}
